/** @jsx jsx */

import React, { Fragment as _, useLayoutEffect } from 'react';
import { css, jsx } from '@emotion/core';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Box } from '@chameleoncreator/creator-ui';
import useImageLoader from 'hooks/useImageLoader';

const Background = ({ background, backgroundImageOpacity }) => {
  const imgLoadedState = useImageLoader(
    background ? background.split(/\(|\)/g)[1] : ''
  );

  const opacity = backgroundImageOpacity / 100;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        ...(background && {
          background: `url('${background}') no-repeat`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }),
        // ...(background && background.includes('url')
        //   ? {
        //       background,
        //       opacity: imgLoadedState === 2 ? 1 : 0,
        //       transition: 'opacity 1s',
        //     }
        //   : {
        //       background,
        //       transition: 'background 0.35s',
        //     }),
        opacity,
        pointerEvents: 'none',
      }}
    />
  );
};

const TopicContainer = props => {
  const { state, topic, children } = props as any;

  const block: any = getBlockById(topic.id);
  let {
    sId,
    src,
    backgroundImage,
    backgroundImageOpacity = 100,
  }: any = getBlockById(topic.id).props;

  // console.log('TOPIC sId :', sId);

  // dirty gotta try and cover for legacy backgroundImage
  if (src) {
    backgroundImage = src;
  }

  const backgroundColor =
    block.props.backgroundColor || state.theme.backgroundColor || '';

  const textColor = block.props.textColor || state.theme.textColor || '';

  const opacity = backgroundImageOpacity / 100;
  // console.log(opacity);

  return (
    <Box
      className="fader_-5s"
      id="main"
      tabindex="-1"
      css={css`
        position: relative;
        // width: 100vw;
        // height: 100vh;
        background: ${backgroundColor};
      `}
    >
      <Background
        background={backgroundImage}
        backgroundImageOpacity={backgroundImageOpacity}
      />

      {children}
    </Box>
  );

  return (
    <Box
      className="fader_-5s"
      id="main"
      tabindex="-1"
      css={css`
            background: ${backgroundColor} url('${backgroundImage}') no-repeat;
            background-attachment: fixed;
            background-position: center;
            background-size: cover;
            transition: background 0.3s;
            opacity: ${opacity};
            
            ${textColor &&
              `
            // .chameleon-text {
            //   color: ${textColor};
            // }
            `}
      `}
    >
      {children}
    </Box>
  );
};

export default TopicContainer;
